import AbstractContext from '@/shared/models/AbstractContext';
import DriveBookingDetails from './DriveBookingDetails';
import { present } from '@/shared/utils/typescript';
import DriveBooking from './DriveBooking';
import ContactContext from '@/contact/models/ContactContext';
import Dossier from '@/dossier/models/Dossier';

export default class DriveBookingContext extends AbstractContext {
  driveBookings: Array<DriveBooking> = [];
  selectedDriveBooking: DriveBookingDetails | null = null;

  constructor(readonly contactContext: ContactContext, readonly dossier: Dossier) {
    super();
  }

  clone(): DriveBookingContext {
    return new DriveBookingContext(this.contactContext, this.dossier);
  }

  getSelectedDriveBooking(): DriveBookingDetails {
    return present(this.selectedDriveBooking);
  }
}